import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
